<template>
  <div id="page-product-details">
    <commercial-product-form
        v-model="model"
        ref="form"
        @add-dynamic-product="addDynamicProduct"
        @add-dynamic-bundle="addDynamicBundle"
        :loading="loading"
        card-title="Create Commercial Product"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'commercial-products.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="create"
              class="my-4"
              color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CommercialProductForm from "@/views/pages/commercial-products/CommercialProductForm";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "CommercialProductCreate",
  components: {
    CommercialProductForm
  },
  mixins: [NotificationMixin, SaveModelMixin],
  data() {
    return {
      model: {},
      loading: false,
      references: [
        'Product_FK',
        'ProductCategory_RiskCode_FK',
        'ProductCategory_SubRiskCode_FK',
        'ProductOwner_FK',
        'CommercialProductNode_FK',
        'ClaimNotification_FK',
        'ParentCommercialProduct_FK',
        'SalesCountryType_FK',
      ],
    };
  },
  methods: {
    addDynamicProduct(value) {
      this.references.push(value);
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = await this.getParams();

      try {
        const {data} = await this.$api.commercialProducts.create(params);
        this.notifySuccess('Commercial Product created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Commercial Product failed to be created');
        console.error(e)
      } finally {
      }
    }
  },
};
</script>

<style scoped>

</style>
